function initUpbrighter() {
  // Skip the script if it's on the homepage
  if ($('body').hasClass('template-index')) {
    return;
  }

  /* FlexSlider init moved inline to product.liquid (runs at parse time to avoid init flash) */

  /* Row height-matching — disabled for testing (26.07.2026)
  if ($(window).width() > 768) {
    var numbers_array = [];
    $(".thisisrow3 a.grid-product__image-link").each(function() {
      var getheight = $(this).height();
      numbers_array.push(getheight);
    });
    var biggest = Math.min.apply(null, numbers_array);
    biggest = biggest + "px";
    $(".thisisrow3 a.grid-product__image-link img").css("max-height", biggest);

    var numbers_array1 = [];
    $(".thisisrow1 a.grid-product__image-link").each(function() {
      var getheight1 = $(this).height();
      numbers_array1.push(getheight1);
    });
    var biggest1 = Math.min.apply(null, numbers_array1);
    biggest1 = biggest1 + "px";
    $(".thisisrow1 a.grid-product__image-link img").css("max-height", biggest1);

    var numbers_array2 = [];
    $(".thisisrow2 a.grid-product__image-link").each(function() {
      var getheight2 = $(this).height();
      numbers_array2.push(getheight2);
    });
    var biggest2 = Math.min.apply(null, numbers_array2);
    biggest2 = biggest2 + "px";
    $(".thisisrow2 a.grid-product__image-link img").css("max-height", biggest2);

    var numbers_array4 = [];
    $(".thisisrow4 a.grid-product__image-link").each(function() {
      var getheight4 = $(this).height();
      numbers_array4.push(getheight4);
    });
    var biggest4 = Math.min.apply(null, numbers_array4);
    biggest4 = biggest4 + "px";
    $(".thisisrow4 a.grid-product__image-link img").css("max-height", biggest4);
  }

  if (($(window).width() > 590) && ($(window).width() < 769)) {
    var numbers_array1 = [];
    $(".tabrow1 a.grid-product__image-link").each(function() {
      var getheight1 = $(this).height();
      numbers_array1.push(getheight1);
    });
    var biggest1 = Math.min.apply(null, numbers_array1);
    biggest1 = biggest1 + "px";
    $(".tabrow1 a.grid-product__image-link img").css("max-height", biggest1);

    var numbers_array3 = [];
    $(".tabrow3 a.grid-product__image-link").each(function() {
      var getheight3 = $(this).height();
      numbers_array3.push(getheight3);
    });
    var biggest3 = Math.min.apply(null, numbers_array3);
    biggest3 = biggest3 + "px";
    $(".tabrow3 a.grid-product__image-link img").css("max-height", biggest3);

    var numbers_array2 = [];
    $(".tabrow2 a.grid-product__image-link").each(function() {
      var getheight2 = $(this).height();
      numbers_array2.push(getheight2);
    });
    var biggest2 = Math.min.apply(null, numbers_array2);
    biggest2 = biggest2 + "px";
    $(".tabrow2 a.grid-product__image-link img").css("max-height", biggest2);

    var numbers_array4 = [];
    $(".tabrow4 a.grid-product__image-link").each(function() {
      var getheight4 = $(this).height();
      numbers_array4.push(getheight4);
    });
    var biggest4 = Math.min.apply(null, numbers_array4);
    biggest4 = biggest4 + "px";
    $(".tabrow4 a.grid-product__image-link img").css("max-height", biggest4);

    var numbers_array5 = [];
    $(".tabrow5 a.grid-product__image-link").each(function() {
      var getheight5 = $(this).height();
      numbers_array5.push(getheight5);
    });
    var biggest5 = Math.min.apply(null, numbers_array5);
    biggest5 = biggest5 + "px";
    $(".tabrow5 a.grid-product__image-link img").css("max-height", biggest5);

    var numbers_array6 = [];
    $(".tabrow6 a.grid-product__image-link").each(function() {
      var getheight6 = $(this).height();
      numbers_array6.push(getheight6);
    });
    var biggest6 = Math.min.apply(null, numbers_array6);
    biggest6 = biggest6 + "px";
    $(".tabrow6 a.grid-product__image-link img").css("max-height", biggest6);
  }
  */

  $(window).resize(function() {
    /* Row height-matching — disabled for testing (26.07.2026)
    if ($(window).width() > 768) {
      ... (same thisisrowN block as above) ...
    }

    if (($(window).width() > 590) && ($(window).width() < 769)) {
      ... (same tabrowN block as above) ...
    }

    if ($(window).width() < 591) {
      $(".yuyuy .grid__item .grid-product__image").css("max-height", "auto");
    }
    */
  });

  $(window).scroll(function() {
    if ($(window).width() < 480) {
      if ($(window).scrollTop() >= 10) {
        $('.header-wrapper').addClass('fixed-header');
      } else {
        $('.header-wrapper').removeClass('fixed-header');
      }
    } else {
      if ($(window).scrollTop() >= 70) {
        $('.header-wrapper').addClass('fixed-header');
      } else {
        $('.header-wrapper').removeClass('fixed-header');
      }
    }
  });

$("#AddToCart").hover(function() {
  $('#add_cart_icon .fa-shopping-bag').css("color", "#abff84");
}, function() {
  $('#add_cart_icon .fa-shopping-bag').css("color", "");
});}

$(initUpbrighter);

var flexResizeTimer;
$(window).on('resize', function() {
  clearTimeout(flexResizeTimer);
  flexResizeTimer = setTimeout(function() {
    if ($('.flexslider').data('flexslider')) {
      $('.flexslider').data('flexslider').resize();
    }
  }, 250);
});